<!-- 
  详情页 - 负责人部门-负责人
  props:
    type: 分配类型0员工1部门
    id：相关产品id
  emit: 
    refresh: 提交刷新父组件请求
 -->
 <template>
 <div class="product-person">
   <el-dialog title="批量分配" width="600px" :visible.sync="dialogVisible" :modal="false">
     <template v-if="type === 0">
        <el-input size="small" prefix-icon="el-icon-search" v-model="nameLike" @change="handleSearch" placeholder="员工搜索">
        </el-input>
        <ul class="staff">
          <li v-for="user in userList">
            <div class="staffLeft">
              <img :src="user.userAvatar" width="30"/>
              <span>{{user.userName}}</span>
            </div>
            <template>
              <div class="rightCheck">
                <el-checkbox v-if="user.selectType === 1 && user.isIndeterminate" 
                 :indeterminate="user.isIndeterminate" @change="checkedHalf(user)"></el-checkbox>
                <el-checkbox v-else v-model="user.selected" @change="checkedNoOrYes(user)"></el-checkbox>
              </div>
            </template>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="depart">
          <el-tree
            :data="departmentTree"
            :props="defaultProps"
            :check-strictly="true"
            :default-checked-keys="selectIds"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            @check-change="departChange"
            :render-content="renderContent">
          </el-tree>
        </div>  
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBution">保 存</el-button>
      </div>
   </el-dialog>
   <div class="detail-bg"></div>
 </div>
</template>
<script>
import Vue from 'vue'
import * as api from 'src/api'
import { Message } from 'element-ui'
let lazy
export default {
  created () {
    this.dialogVisible = true
    this.getStaffOrDep()
  },
  props: {
    // 员工0部门1
    type: {
      type: Number
    },
    id: {
      type: Array
    }
  },
  data () {
    return {
      dialogVisible: false,
      userList: [], // 员工数组
      nameLike: '', // 搜索值
      departmentTree: [], // 部门列表
      // Tree组件的默认格式
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      selectArr: [], // 已选
      unselectArr: [], // 未选
      selectIds: [], // 部门选中的
      defaultpartArr: [] // 部门部分选中
    }
  },
  computed: {
    distributionType () {
      let distributionType
      // 判断是部门分配还是员工分配
      if (this.type === 1) {
        distributionType = 'department'
      } else if (this.type === 0) {
        distributionType = 'user'
      }
      return distributionType
    }
  },
  methods: {
    // 获取员工或者部门
    getStaffOrDep () {
      let url = `/productApi/getPortionedUserOrDepartment.html`
      let params = {
        nameLike: this.nameLike,
        distributionType: this.distributionType, // 部门或员工
        productIds: this.id
      }
      api.post(url, params, (data) => {
        if (this.type === 0) {
          // this.userList = data.userList // 员工数组
          this.userList = data.userList.map((item) => {
            if (item.selectType === 1) {
              item.isIndeterminate = true
            } else if (item.selectType === 2) {
              item.selected = true
            } else if (item.selectType === 0) {
              item.selected = false
            }
            return item
          })
        } else { // 部门数组
          this.departmentTree = data.departmentTree
          if (data.partSelectedDepList.length) {
            this.defaultpartArr = data.partSelectedDepList
          }
          if (data.allSelectedDepList.length) {
            this.selectIds = data.allSelectedDepList
          }
        }
      })
    },

    // 搜索
    handleSearch (query) {
      query = query.toString().trim()
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => {
        this.getStaffOrDep()
      }, 500)
    },
    checkedHalf (user) {
      if (user.isIndeterminate) {
        Vue.set(user, 'isIndeterminate', false)
        Vue.set(user, 'selected', true)
      }
    },
    checkedNoOrYes (user) {
      console.log(user)
    },

    // 获取要提交的选中的部门
    departChange (obj, status) {
      if (status) {
        this.selectArr.push(obj.id)
      } else {
        this.unselectArr.push(obj.id)
        // this.selectArr = this.selectArr.filter(item => {
        //   if (item.id !== obj.id) {
        //     return item.id
        //   }
        // })
      }
    },
    // 部门部分分配样式
    renderContent (h, { node, data, store }) {
      if (this.defaultpartArr.indexOf(node.key) > -1) {
        return (
          <span>
              <span>
                <span>{node.label}</span>
              </span>
              <span style="float: right;position: absolute;right: 8px;">
                <span on-click={ (event) => this.hidePart(event) }>
                  <el-checkbox indeterminate></el-checkbox>
                </span>
              </span>
          </span>)
      } else {
        return (
          <span>
              <span>
                <span>{node.label}</span>
              </span>
          </span>)
      }
    },

    // 去掉部门选中状态
    hidePart (event) {
      event.target.style.display = 'none'
    },

    // 保存
    submitBution () {
      let params
      let checkedIds = []
      let unCheckedIds = []
      // 员工分配
      if (this.type === 0) {
        this.userList.map((item) => {
          if (item.selected) {
            checkedIds.push(item.userId)
          } else {
            unCheckedIds.push(item.userId)
          }
        })
      // 部门分配
      } else {
        checkedIds = this.selectArr
        unCheckedIds = this.unselectArr
      }
      let url = `/productApi/portion.html`
      params = {
        productIds: this.id,
        distributionType: this.distributionType,
        checkedIds: checkedIds,
        unCheckedIds: unCheckedIds
      }
      api.post(url, params, (data) => {
        if (data.code === 1) {
          Message({
            type: 'success',
            message: data.msg
          })
          this.$emit('refresh')
          this.dialogVisible = false
        } else {
          Message({
            type: 'error',
            message: data.msg
          })
        }
      })
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('closeDialog')
      }
    }
  },
  components: {
  }
}
</script>
<style lang="less">
  .product-person {
    .el-dialog--small {
      width: 600px;
    }
    .staff,.depart{height:410px;overflow: auto;}
    .staff li{
      height: 30px;
      padding: 5px 0;
      border-bottom: 1px solid #ddd;
      img{float:left;}
      span{float:left;line-height: 30px;padding-left: 10px;}
    }
    .staffLeft{
      width:80%;
      float: left;
      .el-checkbox-group{display: inline-block;}
      img{display: inline-block;}
    }
    .rightCheck{float: right;margin-top: 8px;}
    .el-tree-node__content{position: relative;}
    .el-tree-node__content > .el-checkbox{float:right;}
    .hidePart{display:none;}
  }
</style>
<style lang="less" scope>
  .product-person{
  }
</style>


// WEBPACK FOOTER //
// product-person.vue?375c5b36